export default {
	logo: {
		alt: 'L’Assurance Maladie'
	},
	logoMinistere: {
		alt: 'Ministère de la Santé et de l\'Accès aux Soins'
	},
	logoHauteAutoriteSante: {
		alt: 'Haute Autorité de Santé'
	}
};
